import { HttpResponse, HttpService } from '@application/http.service';
import type { CaseApiModel } from '@visiba/api-vcs-client-v2';
import { Injectable } from '@visiba/instantiation';
import { ParameterHandler } from '@visiba/std';
import { ApiBaseClient } from './_api_base_client';

@Injectable()
export class CasesApiService extends ApiBaseClient {
	constructor(private readonly httpService: HttpService) {
		super('cases');
	}

	public deleteNewIncoming(callticket: string): HttpResponse<unknown> {
		return this.httpService.delete(`${this.baseUri}/newIncoming/appointment/${callticket}`);
	}

	public get(from?: VisibaDate, to?: VisibaDate): HttpResponse<CaseApiModel[]> {
		const parameterHandler = new ParameterHandler();
		parameterHandler.append({
			from: from?.format('YYYY-MM-DD') ?? null,
			to: to?.format('YYYY-MM-DD') ?? null,
		});

		return this.httpService.get(`${this.baseUri}${parameterHandler.getString()}`);
	}
}
